import React, { PureComponent } from 'react'
import withSizes from 'react-sizes'
import ClearChart from './ClearChart'
import ChartHeaderText from './HeaderText'
import { connect } from 'react-redux'
import { HorizontalBar } from 'react-chartjs-2'
import { number, object, func } from 'prop-types'
import { filterSignsBySub } from '../../../../store/Actions'
import { updateClusterColor } from '../../../../store/Actions/MapActions'
import { Card } from 'semantic-ui-react'

class Chart extends PureComponent {
  handleFilter = e => {
    if (e[0] && this.props.isNotMobile) {
      this.props.filterSignsBySub(e[0]._model.label)
      this.props.updateClusterColor(e[0]._view['backgroundColor'])
    }
  }

  render() {
    return (
      <Card fluid raised style={{ borderTop: 'none', marginTop: '0px' }}>
        <HorizontalBar
          data={this.props.chartData}
          legend={{ display: false }}
          getElementAtEvent={e => this.handleFilter(e)}
          style={{ borderTop: 'none' }}
        />
        <ClearChart />
        <ChartHeaderText />
      </Card>
    )
  }
}

Chart.propTypes = {
  radius: number.isRequired,
  chartData: object.isRequired,
  filterSignsBySub: func.isRequired,
}

const mapStateToProps = ({ signsState, map, spi, ui }) => ({
  subCategory: spi.subCategory,
  radius: map.cache.radius,
  chartData: ui.chartData,
})

const mapSizesToProps = ({ width }) => ({
  isNotMobile: width >= 768,
})

const mapDispatchToProps = dispatch => ({
  filterSignsBySub: sub => dispatch(filterSignsBySub(sub)),
  updateClusterColor: value => dispatch(updateClusterColor(value)),
})

export default withSizes(mapSizesToProps)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Chart)
)



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/SubTypeChart/Chart.jsx